import { afterNextRender, Component, computed, Inject, inject, OnInit, PLATFORM_ID, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeFlexModel, HomeModel } from '@core/models/domains/home-page-flex';
import { HomeUiService } from '../home-ui.service';
import { BehaviorSubject, map, Observable, take } from 'rxjs';
import { fadeAnimation } from '../home-page-wrapper.component';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { SwiperOptions } from 'swiper';
import { WINDOW } from '../header/header.component';
import { LoadingService } from '@shared/services/loading.service';
import { isPlatformBrowser } from '@angular/common';
import { typeCrad } from '../sections/popular-hotels-section/card.model';
import { DatepickerService } from '@shared/services/datepicker.service';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import { AuthService } from '@core/services/authentication/auth.service';
@Component({
 selector: 'iho-sepcial-wrapper',
 templateUrl: './sepcial-wrapper.component.html',
 styleUrls: ['./sepcial-wrapper.component.scss'],
 animations: [fadeAnimation],
})
export class SepcialWrapperComponent {
    router = inject(Router);
    homeUiService = inject(HomeUiService);
    route = inject(ActivatedRoute);
    searchBoxService = inject(SearchBoxService);
    dataSource:any;
    allSections!: any[];
    allSections$!: Observable<any[]>;
    resetSwiper: WritableSignal<boolean> = signal(true);
    specialDataSource = this.homeUiService.getAllSections('special').pipe(take(1))!;
    SuggestedTypes!: Observable<any>;
    
  ngOnInit(): void {
      this.allSections$ = this.homeUiService.getAllSections('special').pipe(
          map((data:any) => {
            return  data.Sections;
          })
       );
   
      this.SuggestedTypes = this.homeUiService.getAllSections('special').pipe(
          map((data: any) => {
              return data.SuggestedTypes.Data
          })
      );
     
     
  }
 
  public StateEnum = typeCrad;
 
  config: SwiperOptions = {
   slidesPerView: 4,
   loop: true,
   grabCursor: true,
 
   observer: true, // adding this solve my issue
   pagination: {
    clickable: true,
   },
  };
}
